import { render, staticRenderFns } from "./SubRadioButton.vue?vue&type=template&id=31416959&"
import script from "./SubRadioButton.vue?vue&type=script&lang=js&"
export * from "./SubRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./SubRadioButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRadio,VRadioGroup,VSelect,VTextField})
